import styled, { css } from 'styled-components';

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
  width: ${({ fullWidth }) => fullWidth ? '100%' : 'auto'};
`;

export const InputLabel = styled.label`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border: 2px solid ${({ theme, error }) => error ? theme.colors.error : theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  transition: all ${({ theme }) => theme.transitions.base};
  
  &:focus-within {
    border-color: ${({ theme, error }) => error ? theme.colors.error : theme.colors.primary};
    box-shadow: 0 0 0 3px ${({ theme, error }) => 
      error ? `${theme.colors.error}20` : `${theme.colors.primary}20`};
  }
  
  ${({ disabled, theme }) => disabled && css`
    opacity: 0.6;
    cursor: not-allowed;
    background-color: ${theme.colors.backgroundTertiary};
  `}
`;

export const StyledInput = styled.input`
  flex: 1;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  padding-left: ${({ hasLeftIcon, theme }) => hasLeftIcon ? theme.spacing.xl : theme.spacing.md};
  padding-right: ${({ hasRightIcon, theme }) => hasRightIcon ? theme.spacing.xl : theme.spacing.md};
  font-size: ${({ theme }) => theme.fontSizes.base};
  color: ${({ theme }) => theme.colors.textPrimary};
  background: transparent;
  border: none;
  outline: none;
  height: 44px;
  
  &::placeholder {
    color: ${({ theme }) => theme.colors.textTertiary};
  }
  
  &:disabled {
    cursor: not-allowed;
  }

  /* Remove autofill background */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px ${({ theme }) => theme.colors.backgroundSecondary} inset;
    -webkit-text-fill-color: ${({ theme }) => theme.colors.textPrimary};
    transition: background-color 5000s ease-in-out 0s;
  }
`;

export const InputIcon = styled.span`
  position: absolute;
  ${({ position }) => position === 'left' ? 'left: 12px' : 'right: 12px'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.textTertiary};
  font-size: 18px;
  pointer-events: none;
`;

export const TogglePasswordButton = styled.button`
  position: absolute;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.textTertiary};
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  transition: color ${({ theme }) => theme.transitions.fast};
  
  svg {
    width: 18px;
    height: 18px;
  }
  
  &:hover {
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;

export const ErrorMessage = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.colors.error};
  margin-top: -4px;
`;

export const HelperText = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-top: -4px;
`;

